export default "__VITE_ASSET__my1sd1Zn__"